import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function Modules() {
  const modules = [{
    num: 1,
    title: 'ARQUITECTURA DE LA REPOSTERÍA RENTABLE',
    image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?q=80&w=800&auto=format&fit=crop',
    items: ['Manifiesto: De la cocina casera al taller de alta pastelería.', 'Inventario Inteligente: Herramientas esenciales para resultados profesionales (Sin inversión industrial).', 'La Despensa de Oro: Selección de insumos para lograr un sabor premium.', 'Protocolos de Calidad: Higiene, seguridad alimentaria y el arte de la conservación prolongada.']
  }, {
    num: 2,
    title: 'MILHOJAS DE ALTA GAMA (Dominando el Hojaldre Perfecto)',
    image: 'https://images.unsplash.com/photo-1587314168485-3236d6710814?q=80&w=800&auto=format&fit=crop',
    items: ['Anatomía de la Milhoja: Estética y texturas que enamoran.', 'Técnicas de Laminado Maestro: Paso a paso para un hojaldre crujiente y aireado.', 'El Horno como Aliado: Tiempos y temperaturas para el dorado caramelo perfecto.', 'Alta Cremería: Receta secreta de la Crema Pastelera Sedosa (Resistente y firme).', 'Alquimia de Sabores: Rellenos de especialidad (Dulce de Leche Premium, Coulis de Frutos Rojos y Ganache de Chocolate Blanco).', 'Ingeniería del Corte: El método del cuchillo de sierra para un acabado limpio y profesional.']
  }, {
    num: 3,
    title: 'GALLETAS GOURMET (La Tendencia del Momento)',
    image: 'https://images.unsplash.com/photo-1499636136210-6f4ee915583e?q=80&w=800&auto=format&fit=crop',
    items: ['Física de la Galleta: La guía definitiva para controlar suavidad vs. crocancia.', 'The Signature Cookie: Mi receta maestra de New York Chocolate Chip.', 'Colección de Rellenos Explosivos: Nutella Core, Red Velvet Velvet y Pistacho Royale.', 'El Secreto del Reposo: Por qué el frío es el ingrediente invisible del éxito.', 'Estilismo de Postres: Técnicas de decoración para un impacto visual inmediato.']
  }, {
    num: 4,
    title: 'EL NEGOCIO DULCE (De Hobby a Emprendimiento)',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=800&auto=format&fit=crop',
    items: ['Ingeniería de Costos: Cómo calcular tu margen de beneficio real y no perder dinero.', 'Branding & Unboxing: Creando una experiencia de lujo a través del empaque.', 'WhatsApp Business para Reposteras: Automatización y cierre de pedidos sin estrés.', 'Content Design: Fotografía gastronómica con celular para vender más en Instagram.']
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative" data-id="element-184">
      <div className="dashed-divider absolute top-0 left-0" data-id="element-185"></div>

      <div className="max-w-5xl mx-auto" data-id="element-186">
        <div className="text-center mb-16" data-id="element-187">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-espresso mb-6" data-id="element-188">
            Lo que encontrarás dentro
          </h2>
          <p className="text-lg text-espresso-light font-sans max-w-2xl mx-auto" data-id="element-189">
            Un temario diseñado estratégicamente para llevarte desde cero hasta
            tu primera venta exitosa.
          </p>
        </div>

        <div className="space-y-12" data-id="element-190">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-3xl overflow-hidden shadow-soft flex flex-col md:flex-row border border-caramel/10" data-id="element-191">
              <div className="md:w-2/5 relative h-64 md:h-auto" data-id="element-192">
                <img src={mod.image} alt={mod.title} className="w-full h-full object-cover" data-id="element-193" />
                <div className="absolute inset-0 bg-gradient-to-t from-espresso/80 via-espresso/20 to-transparent flex flex-col justify-end p-6" data-id="element-194">
                  <div className="bg-caramel text-white text-sm font-bold px-3 py-1 rounded-full w-max mb-2" data-id="element-195">
                    MÓDULO {mod.num}
                  </div>
                </div>
              </div>

              <div className="md:w-3/5 p-8 md:p-10" data-id="element-196">
                <h3 className="text-2xl font-serif font-bold text-espresso mb-6 leading-tight" data-id="element-197">
                  {mod.title}
                </h3>
                <ul className="space-y-4" data-id="element-198">
                  {mod.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-199">
                      <BookOpen className="w-5 h-5 text-caramel shrink-0 mt-0.5" data-id="element-200" />
                      <span className="text-espresso-light font-sans leading-relaxed" data-id="element-201">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}